import clsx from "clsx";
import { Hand } from "lucide-react";

/** Small hand badge on participant tiles (Google Meet style). */
export function LiveInterviewHandRaisedSymbol({ className, size = "md" }) {
  const iconSize = size === "sm" ? 14 : 16;

  return (
    <span className={clsx("li-hand-raised-badge", `is-${size}`, className)} aria-hidden>
      <Hand size={iconSize} strokeWidth={2.25} />
    </span>
  );
}
